var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 18,
    viewBox: "0 0 29 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 9.002c.012.304.137.656.344.877l6.788 7.225c.46.414 1.343.585 1.857.106.506-.47.49-1.386-.013-1.86l-4.773-5.073h22.524a1.274 1.274 0 1 0 0-2.55H4.703l4.773-5.073c.434-.436.514-1.383.013-1.86C8.987.317 8.074.47 7.632.901L.844 8.125a1.23 1.23 0 0 0-.344.877"
  })));
};
export default SvgArrowLeft;